import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { MainLayout } from "@/components/layout/MainLayout";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { GlobalErrorModal } from "@/components/modals/GlobalErrorModal";
import Index from "./pages/Index";
import { Login } from "./pages/Login";
import { Register } from "./pages/Register";
import { ProductsLayout } from "./pages/products/orderManagement/ProductsLayout";
import { ProductsIndex } from "./pages/products/orderManagement/ProductsIndex";
import { OrderManage } from "./pages/products/orderManagement/OrderManage";
import { Analytics } from "./pages/products/Analytics";
import { Admin } from "./pages/products/Admin";
import { PartiesLayout } from "./pages/parties/PartiesLayout";
import { PartiesIndex } from "./pages/parties/PartiesIndex";
import { Events } from "./pages/parties/Events";
import { Locations } from "./pages/parties/Locations";
import { TestPage } from "./pages/TestPage";
import { AI } from "./pages/AI";
import { TrainingDataPage } from "./pages/trainingData/TrainingDataPage";
import { CmsList } from "./pages/cms/CmsList";
import { CmsDetail } from "./pages/cms/CmsDetail";
import NotFound from "./pages/NotFound";
import { Politics } from "./pages/Politics";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <AuthProvider>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <GlobalErrorModal />
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            
            <Route
              path="/*"
              element={
                <ProtectedRoute>
                  <MainLayout>
                    <Routes>
                      <Route path="/" element={<Index />} />
                      <Route path="/test" element={<TestPage />} />
                      <Route path="/ai" element={<AI />} />
                      <Route path="/politics" element={<Politics />} />
                      <Route path="/training-data" element={<TrainingDataPage />} />

                      {/* Customers (CMS) routes */}
                      <Route path="/cms" element={<CmsList />} />
                      <Route path="/cms/:id" element={<CmsDetail />} />

                      
                      {/* Products routes */}
                      <Route path="/products" element={<ProductsLayout />}>
                        <Route index element={<ProductsIndex />} />
                        <Route path="ordermanage" element={<OrderManage />} />
                        <Route path="analytics" element={<Analytics />} />
                        <Route path="admin" element={<Admin />} />
                      </Route>
                      
                      {/* Parties routes */}
                      <Route path="/parties" element={<PartiesLayout />}>
                        <Route index element={<PartiesIndex />} />
                        <Route path="events" element={<Events />} />
                        <Route path="locations" element={<Locations />} />
                      </Route>
                      
                      <Route path="*" element={<NotFound />} />
                    </Routes>
                  </MainLayout>
                </ProtectedRoute>
              }
            />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </AuthProvider>
  </QueryClientProvider>
);

export default App;
